/** Web Push (VAPID) yardımcıları. İzin isteği yalnız kullanıcı tıklaması içinde çağrılmalı. */
import { api } from "@/lib/api";

const toUint8 = (base64) => {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const raw = atob((base64 + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

export const pushPermission = () =>
  "Notification" in window ? Notification.permission : "unsupported";

export async function enablePush() {
  if (!pushSupported()) throw new Error("Bu tarayıcı bildirim desteklemiyor.");
  if (isIOS() && !isStandalone()) {
    throw new Error(
      "iPhone/iPad'de bildirim için önce Paylaş → Ana Ekrana Ekle ile uygulamayı kurun.",
    );
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Bildirim izni verilmedi.");

  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    const { data } = await api.get("/push/public-key");
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: toUint8(data.public_key),
    });
  }
  const json = subscription.toJSON();
  await api.post("/push/subscriptions", { endpoint: json.endpoint, keys: json.keys });
  return true;
}

export async function disablePush() {
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return true;
  await api
    .delete("/push/subscriptions", { params: { endpoint: subscription.endpoint } })
    .catch(() => {});
  await subscription.unsubscribe();
  return true;
}
